import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ModalCargaExamenPdfService {

	constructor(private http: HttpClient) { }

	cargarExamenConAdjunto(body: any): Observable<any> {
		const options = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
			responseType: 'text' as 'json'
		};
		return this.http.post(this.buildURL(), body, options);
	}

	buildURL() {
		return `${environment.apiUrl}estudios/carga-con-adjunto`;
	}

}
